export function RedirectCode400(status = null) {
//   const role = JSON.parse(localStorage.getItem("user"));
//   if (role?.["auth"]["role"][0] === "MEDICAL_PERSONNEL") {
//     return "/searchDataPatient";
//   } else if (role?.["auth"]["role"][0] === "LABORATORY_ADMIN") {
//     // return "/laboratory/inputdata";
//     return "/inspectionGuide";
//   } else if (role?.["auth"]["role"][0] === "LABORATORY_PERSONNEL") {
//     return "/laboratory/inputdata";
//   } else if (role?.["auth"]["role"][0] === "PATIENT") {
//     return "/patient/laboratoryresult";
//   } else if (role?.["auth"]["role"][0] === "ADMIN") {
//     return "/admin/usermanagement";
//   } else if (role?.["auth"]["role"][0] === "EXECUTIVE") {
//     return "/manager/aggregateResult";
//   } else if (role?.["auth"]["role"][0] === "HOSPITAL") {
//     return "/hospital/setting";
//   } else if (role?.["auth"]["role"][0] === "HOSPITAL_PERSONNEL") {
//     return "/";
//   } else {
//     return "/login";
//   }
    if(status){
        return "/404"
    }else{
        const role = JSON.parse(localStorage.getItem('user'))
        if (role?.['auth']['role'][0]) {
            return "/";
        } else {
            return "/login";
        }
    }
}
